import GlobalStyles from '@mui/material/GlobalStyles';
import type { TableRowType } from 'components/editor/grid/reduxStore/table.types';
import { getCellStyles } from 'muiTheme/cellStyles';
import { useId, useMemo } from 'react';

// Emits the table's cell styles as memoized global styles scoped to a per-table class, so the rules are only
// re-serialized when the rows change rather than on every render of the table.
export function useCellStyles(rows: Pick<TableRowType, 'id' | 'cellConfig'>[] | undefined) {
  const id = useId();
  const cellStylesClassName = `py-cell-styles-${id.replace(/[^a-zA-Z0-9-]/g, '')}`;

  const cellStyles = useMemo(() => {
    const styles = getCellStyles(rows ?? [], `.${cellStylesClassName}`);
    return Object.keys(styles).length > 0 ? <GlobalStyles styles={styles} /> : null;
  }, [rows, cellStylesClassName]);

  return { cellStylesClassName, cellStyles };
}
